import { getToken } from '../authentication/authModule';
import axios from 'axios';

export default class ApiClient {
	protected baseUrl: string;

	private client: any;

	constructor() {
		this.client = axios.create();
		this.baseUrl = '/api/v1.0';
	}

	request = async<T>(method: string, resourceUrl: string, body?: any, abortSignal?: AbortSignal) => {
		const token = await getToken();
		const request = await this.client(resourceUrl, {
			method,
			data: JSON.stringify(body),
			timeout:200000,
			signal: abortSignal,
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
				'Cache-Control': 'no-cache',
				'Content-Security-Policy':  "frame-ancestors 'none'"
			},
		});
		return request.data as T;
	};

	async get<T>(resourceUrl: string, abortSignal?: AbortSignal) {
		return this.request<T>('GET', `${this.baseUrl}/${resourceUrl}`, undefined, abortSignal);
	}

	async post<T>(resourceUrl: string, body: any) {
		return this.request<T>('POST', `${this.baseUrl}/${resourceUrl}`, body);
	}

	async put<T>(resourceUrl: string, body: any) {
		return this.request<T>('PUT', `${this.baseUrl}/${resourceUrl}`, body);
	}

	async patch<T>(resourceUrl: string, body: any) {
		return this.request<T>('PATCH', `${this.baseUrl}/${resourceUrl}`, body);
	}

	async delete<T>(resourceUrl: string, body: any) {
		return this.request<T>('DELETE', `${this.baseUrl}/${resourceUrl}`, body);
	}

	async postFormData(resourceUrl: string, formData: FormData): Promise<any> {
		const token = await getToken();

		return new Promise(async (resolve, reject) =>
			fetch(`${this.baseUrl}/rules/${resourceUrl}`, {
				method: 'POST',
				headers: {
					Authorization: `Bearer ${token}`,
					Accept: 'application/json, */*',
				},
				body: formData,
			})
			.then((response) => {
				if (!response.ok) throw response;
				return response;
			})
			.then(response => resolve(response.json()))
			.catch(response => response.json())
			.then(response => reject(response))
		);
	}
}